<template>
    <div>
        <PageHeader
            title="WisdomPearls"
            :image="asset('images/helpers/me-blogs.png')"
            :background="asset('images/helpers/blogs-bg.webp')"
            :color="'#303d1d'"
            description="Throughout history, stories have been the vessels through which wisdom is passed down from generation to generation. They have the ability to transcend time and space, connecting us to the experiences, emotions, and insights of others. Whether it's a fable from ancient folklore or a modern-day anecdote, every story has the potential to leave an indelible mark on our lives. WisdomPearl series is a short story with a life lesson to ponder and reflect upon."
        >
            <SearchBar
                @onSubmit="searchSubmit"
                @onClear="searchCleared"
                v-model="searchInput"
            />
        </PageHeader>
        <Container>
            <div class="list" v-if="data.data.length > 0">
                <Item v-for="item in data.data" :key="item.id" :data="item" />
            </div>
            <NoData title="No blogs found" v-else>
                <span></span>
            </NoData>
            <Pagination
                :rawData="data.meta"
                :onClick="pageChange"
                class="mt-4"
            />
        </Container>
    </div>
</template>
<script>
import Item from "./item.vue";
import PageHeader from "../shared/pageHeader.vue";

export default {
    components: {
        Item,
        PageHeader,
    },
    props: {
        data: {
            type: Object,
            default: () => ({
                data: [],
                meta: {},
            }),
        },
        search: {
            type: String,
            default: "",
        },
    },
    watch: {
        search: {
            immediate: true,
            handler(value) {
                this.searchInput = value;
            },
        },
    },
    data() {
        return {
            searchInput: "",
        };
    },
    methods: {
        searchSubmit(search) {
            this.$root.$emit("hold-transition", null);
            this.$inertia.visit(
                this.$route(this.$route().current(), {
                    search: search,
                    page: 1,
                })
            );
        },
        searchCleared() {
            this.$root.$emit("hold-transition", null);
            this.$inertia.visit(
                this.$route(this.$route().current(), {
                    search: "",
                    page: 1,
                })
            );
        },
        pageChange(page) {
            this.$root.$emit("hold-transition", null);
            this.$inertia.visit(
                this.$route(this.$route().current(), {
                    page: page,
                    search: this.searchInput,
                })
            );
        },
    },
};
</script>
<style lang="scss" scoped>
.list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 1.4rem;
}
</style>
